export const onBlur = event => {
  if (!event.target.value)
    $(event.target).closest('label').removeClass('has-focus-or-value')
}

export const onFocus = event => $(event.target).closest('label').addClass('has-focus-or-value')
